import React from 'react';
import { withRouter } from 'react-router-dom';
import ErrMsg from './ErrMsg.jsx';
import WaitMsg from './WaitMsg.jsx';
import SuccessMsg from './SuccessMsg.jsx';
import Home from './Home.jsx';
import Usuarios from './Usuarios.jsx';
import Centros from './Centros.jsx';
import Estoque from './Estoque.jsx';
import Contas from './Contas.jsx';
import Movimentacoes from './Movimentacoes.jsx';
import Relatorios from './Relatorios.jsx';
import MudarSenha from './MudarSenha.jsx';
import CadastrarUsuario from './CadastrarUsuario.jsx';
import VisualizarUsuario from './VisualizarUsuario.jsx';
import EditarUsuario from './EditarUsuario.jsx';
import CadastrarCentro from './CadastrarCentro.jsx';
import VisualizarCentro from './VisualizarCentro.jsx';
import EditarCentro from './EditarCentro.jsx';
import EstoqueCentro from './EstoqueCentro.jsx';
import CadastrarProduto from './CadastrarProduto.jsx';
import VisualizarProduto from './VisualizarProduto.jsx';
import EditarEstoque from './EditarEstoque.jsx';
import AbastecerEstoque from './AbastecerEstoque.jsx';
import BaixaEstoque from './BaixaEstoque.jsx';
import FluxoProduto from './FluxoProduto.jsx';
import FluxoEstoque from './FluxoEstoque.jsx';
import ContasCentro from './ContasCentro.jsx';
import CadastrarConta from './CadastrarConta.jsx';
import VisualizarConta from './VisualizarConta.jsx';
import EditarConta from './EditarConta.jsx';
import TiposConta from './TiposConta.jsx';
import CadastrarTipoConta from './CadastrarTipoConta.jsx';
import VisualizarTipoConta from './VisualizarTipoConta.jsx';
import EditarTipoConta from './EditarTipoConta.jsx';
import Orcamento from './Orcamento.jsx';
import CadastrarOrcamento from './CadastrarOrcamento.jsx';
import MovimentacoesCentro from './MovimentacoesCentro.jsx';
import CadastrarMovimentacao from './CadastrarMovimentacao.jsx';
import VisualizarMovimentacao from './VisualizarMovimentacao.jsx';
import AprovarMovimentacao from './AprovarMovimentacao.jsx';
import CorrigirMovimentacao from './CorrigirMovimentacao.jsx';
import RelatorioContabilidade from './RelatorioContabilidade.jsx';
import RelatorioEstoque from './RelatorioEstoque.jsx';
import ResumoAnual from './ResumoAnual.jsx';
import RelatorioGerencial from './RelatorioGerencial.jsx';
import EditarMovimentacao from './EditarMovimentacao.jsx';
import RemoverMovimentacao from './RemoverMovimentacao.jsx';
import AnexarNotaCorrigida from './AnexarNotaCorrigida.jsx';
import AnexarComprovanteCorrigido from './AnexarComprovanteCorrigido.jsx';

class Content extends React.Component {

    constructor() {

        super();

        this.state = {
            component: {
                "home": <Home />,
                "usuarios": <Usuarios />,
                "centros": <Centros />,
                "estoque": <Estoque />,
                "contas": <Contas />,
                "movimentacoes": <Movimentacoes />,
                "relatorios": <Relatorios />,
                "mudarsenha": <MudarSenha
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "cadastrarusuario": <CadastrarUsuario
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "visualizarusuario": <VisualizarUsuario />,
                "editarusuario": <EditarUsuario
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "cadastrarcentro": <CadastrarCentro
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "visualizarcentro": <VisualizarCentro />,
                "editarcentro": <EditarCentro
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "estoquecentro": <EstoqueCentro />,
                "cadastrarproduto": <CadastrarProduto
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "visualizarproduto": <VisualizarProduto
                    errMsgHandler={ this.setErrMsg.bind(this) } />,
                "editarestoque": <EditarEstoque
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "abastecerestoque": <AbastecerEstoque
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "baixaestoque": <BaixaEstoque
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "fluxoproduto": <FluxoProduto
                    waitMsgHandler={ this.setWaitMsg.bind(this) } />,
                "fluxoestoque": <FluxoEstoque />,
                "contascentro": <ContasCentro />,
                "cadastrarconta": <CadastrarConta
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "visualizarconta": <VisualizarConta />,
                "editarconta": <EditarConta
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "tiposconta": <TiposConta />,
                "cadastrartipoconta": <CadastrarTipoConta
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "visualizartipoconta": <VisualizarTipoConta />,
                "editartipoconta": <EditarTipoConta
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "orcamento": <Orcamento />,
                "cadastrarorcamento": <CadastrarOrcamento
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "movimentacoescentro": <MovimentacoesCentro />,
                "cadastrarmovimentacao": <CadastrarMovimentacao
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "visualizarmovimentacao": <VisualizarMovimentacao
                    errMsgHandler={ this.setErrMsg.bind(this) } />,
                "aprovarmovimentacao": <AprovarMovimentacao
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "corrigirmovimentacao": <CorrigirMovimentacao
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "relatoriocontabilidade": <RelatorioContabilidade
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) } />,
                "relatorioestoque": <RelatorioEstoque
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) } />,
                "resumoanual": <ResumoAnual
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) } />,
                "relatoriogerencial": <RelatorioGerencial
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) } />,
                "editarmovimentacao": <EditarMovimentacao
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "removermovimentacao": <RemoverMovimentacao
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "anexarnotacorrigida": <AnexarNotaCorrigida
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />,
                "anexarcomprovantecorrigido": <AnexarComprovanteCorrigido
                    errMsgHandler={ this.setErrMsg.bind(this) }
                    waitMsgHandler={ this.setWaitMsg.bind(this) }
                    successMsgHandler={ this.setSuccessMsg.bind(this) } />
            },
            errMsg: "",
            waitMsg: "",
            successMsg: localStorage.successMsg
        };

        this.setErrMsg = this.setErrMsg.bind(this);
        this.fecharErrMsg = this.fecharErrMsg.bind(this);
        this.setWaitMsg = this.setWaitMsg.bind(this);
        this.fecharWaitMsg = this.fecharWaitMsg.bind(this);
        this.setSuccessMsg = this.setSuccessMsg.bind(this);
        this.fecharSuccessMsg = this.fecharSuccessMsg.bind(this);

    }

    setErrMsg(msg) {

        this.setState({ errMsg: msg });

        setTimeout(function() {
            this.setState({ errMsg: "" });
        }.bind(this), 3000);

    }

    fecharErrMsg() {
        this.setState({ errMsg: "" });
    }

    setWaitMsg(msg) {
        this.setState({ waitMsg: msg });
    }

    fecharWaitMsg() {
        this.setState({ waitMsg: "" });
    }

    setSuccessMsg(msg) {
        this.setState({ successMsg: msg });
        localStorage.successMsg = msg;
    }

    fecharSuccessMsg() {
        this.setState({ successMsg: "" });
        localStorage.successMsg = "";
    }

    componentDidMount() {

        if (this.state.successMsg !== "") {

            setTimeout(() => {
                this.setState({ successMsg: "" });
                localStorage.successMsg = "";
            }, 3000);

        }

    }

    render() {
        return (
            <div id={ "dashboard-content-" + this.props.toggle }>
                { this.state.errMsg !== "" &&
                    <ErrMsg msg={ this.state.errMsg  } fechar={ this.fecharErrMsg }  /> }
                { this.state.waitMsg !== "" &&
                    <WaitMsg msg={ this.state.waitMsg  } fechar={ this.fecharWaitMsg }  /> }
                { this.state.successMsg !== "" &&
                    <SuccessMsg msg={ this.state.successMsg } fechar={ this.fecharSuccessMsg } /> }
                { this.state.component[this.props.match.params.id] }
            </div>
        );
    }

}

export default withRouter(Content);

